import styled from "styled-components";

const Container = styled.div`
  padding: 20px;
  height: 90vh;

  .ant-table-thead .ant-table-cell {
    background-color: white;
    color: #8c8c8c;
    font-weight: 600;
  }
`;

const SupportMessage = styled.div`
  background-color: #B12D23;
  padding: 10px;
  margin: 5px 5px;
  border-radius: 15px;
  max-width: 85%;
  color: white;
  font-weight: 500;
  font-size: 15px;
  height: fit-content;
  overflow-wrap: break-word;
`;

const ClientMessage = styled.div`
  background-color: #FFD100;
  padding: 10px;
  color: black;
  font-weight: 500;
  margin: 5px 5px;
  font-size: 15px;
  border-radius: 15px;
  max-width: 85%;
  height: fit-content;
`;

export { Container, ClientMessage, SupportMessage };
